import parse from "html-react-parser";

const Project = (props) => {
    const { title, html_url, description, images } = props.WorkData;

    function project() {
        return <div>
            <div className="row">
              <div className="col-md-6">
                <img src={`${images.two_x}`} className="img-fluid rounded" alt={cleanTitle(title)}></img>
              </div>
              <div className="col-md-6">
                <div className="card-body pt-0 px-0">
                  <h2 className='card-title text-light text-gradient mobile-mt'>{cleanTitle(title)}</h2>
                  <div className='card-text text-light'>{parse(description)}</div>
                  {/* <a className='btn btn-dark text-decoration-none' target="_blank" rel="noreferrer" href={`${html_url}`}>View on Dribbble</a> */}
                </div>
              </div>
            </div>
        </div>
    }

    function cleanTitle(checkTitle) {
        checkTitle = checkTitle.replace("amp;", "");
        return checkTitle
    }

    return (
      <div className='col-12 project'>
        <div className="card border-0">
            {project()}
        </div>
      </div>
    );
}

export default Project;